
import { api } from "_shared/_stores/api";
import { logSchemaFailure } from "_shared/_utilities/log-schema-failure";
import Session from "users/__session/session";
import UserInformationSchema, { UserInformationJSON } from "users/information/_schemas/user-information-schema";

export const userInformationApi = api.injectEndpoints({
  endpoints: (build) => ({
    // #region Get
    getUserInformation: build.query<UserInformationJSON, { session: Session }>({
      query: ({ session }) => ({
        url: "users/me",
        headers: {
          Authorization: `Bearer ${session.authToken?.value}`,
        },
      }),
      rawResponseSchema: UserInformationSchema.UserInformationJSONZ,
      onSchemaFailure: logSchemaFailure,
      providesTags: (result) => [
        { type: "UserInformation", id: result?.id ?? "ME" },
      ],
    }),
    // #endregion
  })
});

// #region Exports
export const {
  useGetUserInformationQuery,
} = userInformationApi;
// #endregion